<template lang="pug">
  .logo
    a.img-box(:href='getVideoInfo.logolink')
      img(:src='getVideoInfo.logo')
    .profile
      .author.clearfix(v-if='getVideoInfo.hideuser === 1')
        img.avatar.fl(:src='getVideoInfo.avatar', alt='头像')
        .name 作者：{{ getVideoInfo.nickname }}

      .info.tac(v-if='getVideoInfo.isonpraise === 1')
        span.icon.omit
          i.iconfont.icon-yulan
          strong {{ getVideoInfo.seecount | formatDigt }}
        span.icon.omit(:class='{"active": getVideoZan}', @click='addZan')
          i.iconfont.icon-zan
          strong {{ getVideoZanCount | formatDigt }}
        span.icon.omit(:class='{"active": getVideoCollect}', @click='addCollect')
          i.iconfont.icon-heart

</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'getVideoInfo',
      'getVideoCollect',
      'getVideoZan',
      'getVideoZanCount',
    ]),
  },
  methods: {
    ...mapActions({
      addZan: 'VIDEO_ZAN',
      addCollect: 'ADD_COLLECT',
    }),
  },
}
</script>

<style lang="stylus">
@import '~assets/styles/colors.styl'
$logo-width = 130px

.logo
  .img-box
    display: block
    max-width: $logo-width
    max-height: $logo-width

  .profile
    font-size: 12px
    padding-top: 10px
    color: $--color-white
    $auth-height = 30px

    .avatar
      width: $auth-height
      height: $auth-height
      border-radius: 50%
      border: 2px solid $--color-white
      box-sizing: border-box
      overflow: hidden
    .name
      font-size: 14px
      padding-left: $auth-height + 10px
      line-height: $auth-height

    .info
      font-size: 0
      margin-top: 10px
      .icon
        display: inline-block
        line-height: 20px
        font-size: 13px
        font-family: 'Micorsoft Yahei'
        width: 50px
        overflow: hidden
        cursor: pointer
        &.active
          i
            color: $--color-blue
        i
          position: relative
          top: 2px
          margin-right: 2px
          font-size: 18px
</style>
